/* Explicit calendar-file export. Import and alarm delivery belong to the calendar. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.AsIfRadioCalendar = api;
})(typeof globalThis === 'object' ? globalThis : this, function () {
  'use strict';
  const RADIO_URL = 'https://www.as-if-records.com/pages/radio';
  const parseInstant = (value) => {
    if (typeof value !== 'string') throw new TypeError('Invalid calendar date');
    const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.\d{1,3})?(Z|[+-]\d{2}:\d{2})$/.exec(value);
    if (!match) throw new TypeError('Calendar dates require an ISO timezone');
    const [, year, month, day, hour, minute, second, offset] = match;
    const lastDay = new Date(Date.UTC(Number(year), Number(month), 0)).getUTCDate();
    if (+year < 1970 || +year > 9999 || +month < 1 || +month > 12 || +day < 1 || +day > lastDay || +hour > 23 || +minute > 59 || +second > 59
      || (offset !== 'Z' && (+offset.slice(1, 3) > 14 || +offset.slice(4) > 59 || (+offset.slice(1, 3) === 14 && +offset.slice(4) !== 0)))) throw new TypeError('Invalid calendar date');
    const stamp = Date.parse(value);
    if (!Number.isFinite(stamp)) throw new TypeError('Invalid calendar date');
    return stamp;
  };
  const occurrence = (item, now) => {
    const start = parseInstant(item?.startsAt), end = parseInstant(item?.endsAt);
    if (!Number.isFinite(now) || start <= now || end <= start || end - start > 7 * 86400000) throw new RangeError('Calendar occurrence must be future and bounded');
    const title = String(item?.title || '').trim();
    if (!title || title.length > 2048) throw new TypeError('Invalid calendar title');
    return { start, end, title };
  };
  const canRemember = (item, now = Date.now()) => {
    try { occurrence(item, now); return true; } catch (_) { return false; }
  };
  const text = (value) => String(value).replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/g, '').replace(/\\/g, '\\\\').replace(/\r\n|\r|\n/g, '\\n').replace(/;/g, '\\;').replace(/,/g, '\\,');
  const utc = (stamp) => new Date(stamp).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z');
  const fold = (line) => {
    const encoder = new TextEncoder();
    let result = '', octets = 0;
    for (const character of line) {
      const size = encoder.encode(character).length;
      if (octets + size > 75) { result += '\r\n '; octets = 1; }
      result += character; octets += size;
    }
    return result;
  };
  const hash = (value) => {
    let first = 2166136261, second = 2246822519;
    for (const byte of new TextEncoder().encode(value)) {
      first = Math.imul(first ^ byte, 16777619) >>> 0;
      second = Math.imul(second ^ byte, 3266489917) >>> 0;
    }
    return [first, second].map(part => part.toString(16).padStart(8, '0')).join('');
  };
  const generate = (item, { now = Date.now(), description = '' } = {}) => {
    const { start, end, title } = occurrence(item, now);
    const identity = hash(JSON.stringify([start, end, title]));
    const lines = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//as.if.records//Radio Programme//DE', 'CALSCALE:GREGORIAN', 'BEGIN:VEVENT',
      `UID:radio-${utc(start)}-${identity}@as-if-records.com`, `DTSTAMP:${utc(now)}`, `DTSTART:${utc(start)}`, `DTEND:${utc(end)}`,
      `SUMMARY:${text(title)}`, `DESCRIPTION:${text(String(description).slice(0, 4000))}`, `URL:${RADIO_URL}`, 'TRANSP:TRANSPARENT',
      'BEGIN:VALARM', 'ACTION:DISPLAY', 'TRIGGER:-PT10M', `DESCRIPTION:${text(title)}`, 'END:VALARM', 'END:VEVENT', 'END:VCALENDAR'];
    return lines.map(fold).join('\r\n') + '\r\n';
  };
  const nextOccurrence = (items, reference, now = Date.now()) => {
    if (!Array.isArray(items)) return null;
    const handle = String(reference?.programHandle || '').trim();
    const title = String(reference?.title || '').trim();
    return items.filter(item => item && (handle ? item.programHandle === handle : item.title === title)
      && canRemember(item, now)).sort((a, b) => Date.parse(a.startsAt) - Date.parse(b.startsAt))[0] || null;
  };
  return Object.freeze({ generate, canRemember, nextOccurrence });
});
